import { isFlowRecordInAssignmentPool, isFlowRecordInPrePool } from "./flowEditPageHelper";

export const TRAY_VIEW = {
  MINE: "mine",
  POOL: "pool",
  GENERAL: "general"
};

export const TRAY_TAB_MODE = {
  THREE: "three",
  POOL_GENERAL: "pool-general",
  GENERAL: "general"
};

const THREE_TAB_ROLES = new Set(["pre-manager", "manager", "validator", "editor"]);

export const isSuperOperateRoleKey = (roleKey = "") => {
  const key = String(roleKey || "").trim().toLowerCase();
  return key === "coordinator" || key === "liaison";
};

export const isAssignmentTabRole = (roleKey = "") =>
  THREE_TAB_ROLES.has(String(roleKey || "").trim().toLowerCase());

export const resolveTrayTabMode = (roleKey = "", surface = "") => {
  const key = String(roleKey || surface || "").trim().toLowerCase();
  if (THREE_TAB_ROLES.has(key)) {
    return TRAY_TAB_MODE.THREE;
  }
  return TRAY_TAB_MODE.GENERAL;
};

export const defaultTrayView = (selectedRoleKey = "", surface = "") => {
  const mode = resolveTrayTabMode(selectedRoleKey, surface);
  return mode === TRAY_TAB_MODE.THREE ? TRAY_VIEW.MINE : TRAY_VIEW.GENERAL;
};

/**
 * Quién puede operar según la pestaña. Sin trayView (ficha desde CMI/listado)
 * no restringe: el gate de asignado y canPoolOperate siguen aplicando.
 */
export const canOperateTrayView = ({
  trayView = "",
  selectedRoleKey = "",
  canOperatePool = false
} = {}) => {
  if (!canOperatePool) {
    return false;
  }
  const view = String(trayView || "").trim().toLowerCase();
  if (!view) {
    return true;
  }
  if (view === TRAY_VIEW.POOL) {
    return true;
  }
  if (view === TRAY_VIEW.MINE) {
    return !isSuperOperateRoleKey(selectedRoleKey);
  }
  if (view === TRAY_VIEW.GENERAL) {
    return isSuperOperateRoleKey(selectedRoleKey);
  }
  return true;
};

const normalizeOperateRoleKey = (roleKey = "") => String(roleKey || "").trim().toLowerCase();

/**
 * Panel de control: todos ven el universo; cada perfil opera solo su competencia.
 * Coordinador: todas las fases. Enlace: solo publicados. Circuito: su bandeja,
 * dueño o pool (Gestor también reclama el pool Pre).
 */
export const canOperateCmiRecord = ({
  record,
  roleKey = "",
  roleId = null,
  userId = null
} = {}) => {
  if (!record) {
    return false;
  }
  if (record.deleted) {
    return false;
  }
  const key = normalizeOperateRoleKey(roleKey);
  const published = Boolean(record.published_at);
  if (key === "coordinator" || key.includes("coordinador")) {
    return true;
  }
  if (key === "liaison" || key.includes("enlace")) {
    return published;
  }
  if (published) {
    return false;
  }
  if (isFlowRecordInPrePool(record) && key === "manager") {
    return true;
  }
  const recordRole = Number(record.current_role_catalog_id || 0);
  const myRole = Number(roleId || 0);
  if (!recordRole || !myRole || recordRole !== myRole) {
    return false;
  }
  if (isFlowRecordInAssignmentPool(record)) {
    return true;
  }
  return Number(record.current_user_id) === Number(userId);
};
